export default __webpack_public_path__ + "static/media/motherhood.e4360539.png";